// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eeccbfe7","453":"f7c1488e","455":"6a7497ac","977":"60640796"}[chunkId] + ".chunk.js";
};